import Fuse from "fuse.js";

class HelperMethods {

    createDownloadableItemForClient(base64String: string, filename: string) {
        // Convert the base64 string to binary data
        const byteCharacters = atob(base64String);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: 'application/octet-stream' });

        // Create a download link element
        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = `${filename}.zip`;

        // Simulate a click on the download link to start the download
        downloadLink.click();

        // Clean up the URL object created earlier
        URL.revokeObjectURL(downloadLink.href);
    }

    isSqlServerVersionGreaterOrEqual(version1: string, version2: string) {
        const version1Components = version1.split('.').map(Number);
        const version2Components = version2.split('.').map(Number);

        for (let i = 0; i < 4; i++) {
            if (version1Components[i] > version2Components[i]) {
                return true;
            } else if (version1Components[i] < version2Components[i]) {
                return false;
            }
        }

        // Both versions are equal
        return true;
    }

    getInitials(name: string) {
        const alphaNumericRegex = /[^0-9a-zA-Z\s]/g;
        const multipleWhitespaceRegex = /\s+/g;

        name = name
            .replace(alphaNumericRegex, '')
            .replace(multipleWhitespaceRegex, ' ')
            .toUpperCase();

        const words = name.split(' ');

        const initials = words.slice(0, 2).map(word => word.charAt(0));

        return initials.join('');
    }

    advancedFuseSearch<T>(searchTerm: string, dataToSearch: T[], fieldsToSearch: (keyof T)[]) {
        const fuse = new Fuse(dataToSearch, {
            keys: fieldsToSearch as string[],
            threshold: 0.3, // Adjust for strictness
        });

        return fuse.search(searchTerm).map(result => result.item);
    }
}

export default new HelperMethods();